<template>
    <div style="max-width: 400px; margin: 10vh auto;" class="text-center">
        <br>
        <img src="@/assets/404-image-1.png" class="img-fluid"/>
        <br>
        <br>
        <h1>Licenza non attiva sul tuo account</h1>
        <p>Potresti non aver ancora attivato la tua licenza per questo prodotto, oppure potrebbe essere scaduta</p>
        <br>
        <a :href="publicPath + '#/products'" class="btn btn-secondary">Vai ai tuoi prodotti</a>
        &nbsp;&nbsp;&nbsp;
        <router-link to="/activate" class="btn btn-warning">Attiva un nuovo prodotto</router-link>
    </div>

</template>

<script>
const vueConfig = require("../../../vue.config.js");

export default {
    name: "product-denied",
    data() {
        return {
            publicPath: vueConfig.publicPath,
        }
    }
}
</script>
